import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { DropDownItem } from "../../../models/DropDownItem";
import Checkbox from "./checkBox";
import "./customDropDownList.css";
export enum FilterType {
  CustomAge,
  Country,
  Department,
}
export type Props = {
  items: DropDownItem[];
  onSetSelection: (selection: DropDownItem) => void;
  emptyField: string;
  filterType: FilterType;
  enableTranslate: boolean;
};

const CustomDropDownList: FC<Props> = ({
  items,
  onSetSelection,
  emptyField,
  filterType,
  enableTranslate,
}) => {
  const [showElements, setElementsVisibility] = useState<boolean>(false);
  const [displaySelection, setDisplaySelection] = useState<string>("");
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const style = { color: "#000000", fontSize: "30px" };
  const activeStyle = { color: "#FFFFFF", fontSize: "30px" };
  let chartClasses =
    items.filter((element) => element.selected === true).length > 0
      ? " active"
      : "";
  const dropDown = () => {
    setElementsVisibility(!showElements);
  };
  const selectItem = (item: DropDownItem) => {
    if (filterType === FilterType.CustomAge) {
      items.forEach((element) => {
        element.selected = false;
      });
    }
    item.selected = !item.selected;
    onSetSelection(item);
    if (filterType === FilterType.CustomAge) {
      setElementsVisibility(false);
    }
  };

  const deslectAll = () => {
    items.forEach(function (element) {
      if (element.selected) {
        element.selected = false;
        onSetSelection(element);
      }
    });
    setDisplaySelection(emptyField);
  };

  useEffect(() => {
    let display: string = "";
    if (filterType !== FilterType.CustomAge) {
      items.forEach(function (item) {
        if (item.selected) {
          if (display !== "") {
            display = display.concat(", ");
          }
          display = display.concat(t(item.Element.key));
        }
      });
    } else {
      items.forEach(function (item) {
        if (item.selected) {
          display = item.Element.name;
        }
      });
    }

    if (display === "") {
      display = emptyField;
    }
    setDisplaySelection(display);
  }, [items, t]);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setElementsVisibility(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return (
    <div
      ref={ref}
      className={
        filterType !== FilterType.CustomAge
          ? "select-box--box"
          : "department-select-box--box"
      }
    >
      <div
        className={
          filterType !== FilterType.CustomAge
            ? `select-box--container${chartClasses}`
            : `department-select-box--container${chartClasses}`
        }
      >
        <div className="select-box--selected-item" onClick={dropDown}>
          <div
            className={
              filterType !== FilterType.CustomAge
                ? `display-selection${chartClasses}`
                : `department-display-selection${chartClasses}`
            }
          >
            {displaySelection}
          </div>
          <div className="select-box--arrow">
            {showElements && (
              <button type="button" onClick={dropDown}>
                {filterType === FilterType.CustomAge &&
                  items.filter((element) => element.selected === true)
                    .length === 0 && (
                    <RiArrowDropUpLine style={style}></RiArrowDropUpLine>
                  )}
                {filterType !== FilterType.CustomAge &&
                  items.filter((element) => element.selected === true)
                    .length === 0 && (
                    <RiArrowDropUpLine style={style}></RiArrowDropUpLine>
                  )}
                {filterType !== FilterType.CustomAge &&
                  items.filter((element) => element.selected === true).length >
                    0 && <RiArrowDropUpLine style={style}></RiArrowDropUpLine>}
                {filterType === FilterType.CustomAge &&
                  items.filter((element) => element.selected === true).length >
                    0 && (
                    <RiArrowDropUpLine style={activeStyle}></RiArrowDropUpLine>
                  )}
              </button>
            )}
            {!showElements && (
              <button type="button" onClick={dropDown}>
                {filterType === FilterType.CustomAge &&
                  items.filter((element) => element.selected === true)
                    .length === 0 && (
                    <RiArrowDropDownLine style={style}></RiArrowDropDownLine>
                  )}
                {filterType !== FilterType.CustomAge &&
                  items.filter((element) => element.selected === true)
                    .length === 0 && (
                    <RiArrowDropDownLine style={style}></RiArrowDropDownLine>
                  )}
                {filterType === FilterType.CustomAge &&
                  items.filter((element) => element.selected === true).length >
                    0 && (
                    <RiArrowDropDownLine
                      style={activeStyle}
                    ></RiArrowDropDownLine>
                  )}
                {filterType !== FilterType.CustomAge &&
                  items.filter((element) => element.selected === true).length >
                    0 && (
                    <RiArrowDropDownLine style={style}></RiArrowDropDownLine>
                  )}
              </button>
            )}
          </div>
        </div>
      </div>
      <div
        style={{ display: showElements ? "block" : "none" }}
        className={
          filterType !== FilterType.CustomAge
            ? "select-box--items"
            : "department-select-box--items"
        }
      >
        <div
          className={
            filterType !== FilterType.CustomAge
              ? "items-list"
              : "department-items-list"
          }
        >
          {filterType !== FilterType.CustomAge && (
            <div className="deselectAll">
              <button onClick={deslectAll}>{t("deselect_all")}</button>
            </div>
          )}
          <ul>
            {items.map((item, index) =>
              item.hidden ? undefined : (
                <li key={item.Element.key} tabIndex={index}>
                  <Checkbox
                    enableTranslate={enableTranslate}
                    displayKey={filterType === FilterType.Department}
                    item={item}
                    handleChange={selectItem}
                    isChecked={item.selected}
                  ></Checkbox>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default CustomDropDownList;
